import type { RightPanelView } from '../hooks/useRightPanelState'

export function getRightPanelRenderState({
  rightPanelView,
  hasItineraryData,
  hasTripListRows,
}: {
  rightPanelView: RightPanelView
  hasItineraryData: boolean
  hasTripListRows: boolean
}) {
  const isTimelineView = rightPanelView === 'timeline'
  const isListView = rightPanelView === 'list'

  return {
    shouldShowMap: rightPanelView === 'map',
    shouldShowTimelineEmptyState: isTimelineView && !hasItineraryData,
    shouldShowTripPlanCanvas: isTimelineView && hasItineraryData,
    shouldShowListEmptyState: isListView && !hasTripListRows,
    shouldShowListView: isListView && hasTripListRows,
  }
}
